import { Close } from "@mui/icons-material";
import { Alert, AlertTitle, IconButton } from "@mui/material";
import { forwardRef, ReactNode } from "react";

export type AlertBar = {
  severity: "info" | "error";
  show: boolean;
  title: string;
  message: string | ReactNode;
};

type AlertBarProps = AlertBar & {
  onClose: () => void;
};

const AlertBar = forwardRef<HTMLDivElement, AlertBarProps>(
  ({ severity, title, message, onClose }, ref) => {
    return (
      <Alert
        ref={ref}
        severity={severity}
        sx={{ width: "100%" }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <Close fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle>{title}</AlertTitle>
        {message}
      </Alert>
    );
  },
);

export default AlertBar;
